import { Grid } from '@mui/material';
import Avatar, { AvatarProps } from '@mui/material/Avatar';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { Control, Controller, FieldValues, Path, useWatch } from 'react-hook-form';
import { makeStyles } from 'tss-react/mui';
import { getUserAvatarInitials } from '../../../../sic-lib/utils/userHelpers';
import ColourPicker from './ColourPicker';

//tiny for pre-existing chips, small for incorporating a chip, large for the PageHeader component
type ProfileBadgeProps<T extends FieldValues> = Omit<AvatarProps, 'name'> & {
    name: Path<T>;
    control?: Control<T>;
};

export function EditUserAvatarControl<TFieldValues extends FieldValues>({
    name,
    control,
    ...props
}: ProfileBadgeProps<TFieldValues>) {
    const { classes } = useStyles();

    const items = useWatch({ name: ['firstName', 'lastName', 'userName'] });

    const initials = React.useMemo(
        () => getUserAvatarInitials(items[0], items[1], items[2]),
        [items],
    );

    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { value, onChange }, fieldState: { error } }) => {
                return (
                    <Grid
                        container
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                        spacing={2}
                    >
                        <Grid item>
                            <Avatar
                                sx={{ background: value }}
                                {...props}
                                className={classes.avatar}
                            >
                                {initials}
                            </Avatar>
                        </Grid>
                        <Grid item>
                            <ColourPicker
                                selectHandler={newColor => {
                                    onChange(newColor);
                                }}
                                color={value}
                            />
                        </Grid>
                    </Grid>
                );
            }}
        ></Controller>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    avatar: {
        width: '7rem',
        height: '7rem',
        fontSize: '3rem',
    },
}));
